import { module } from 'angular';

import { default as switchDirectiveName, SwitchDirective } from './switch.directive.ajs';

export default module('contact.commons.toolbox.switch', []).directive(switchDirectiveName, SwitchDirective).name;
